import {BaseRepository} from "@/modern/core/repositories/BaseRepository";
import {AtendimentoModel} from "@/modern/core";

export class AtendimentoRepository extends BaseRepository {
    async getById(id: string) {
        const request = await this.httpClient.get(
            this.baseUrl.generateURL(`encontros/${id}`),
        )
        return this.handleCustomRequest<AtendimentoModel>(
            request,
            (data) => ({
                ...data,
                inscritos: (data.inscritos ?? []).map((c:any) => ({
                    ...c,
                    status: c.presenca === 'PRESENTE' ? 'PRE' : 'AUS'
                })),
            })
        );
    }

    async saveAtendimento(atendimento: any, id: string | number)  {
        const url = this.baseUrl.generateURL(`encontros/${id}/realizacao`);
        const request = await this.httpClient.put(url, atendimento);
        return this.handleSingleRequest<AtendimentoModel>(request);
    }

    async uploadAnexo(
        file: File,
        atendimentoId: string | number,
        justificativa = false
    ) {
        const url = this.baseUrl.addSegment(`encontros/${atendimentoId}`);

        if(justificativa) {
            url.addSegment('upload-falta-justificada')
        } else {
            url.addSegment('upload')
        }

        const formData = new FormData();
        formData.append('anexo', file);
        const request = await this.httpClient.post(url.generateURL(), formData);
        return this.handleSingleRequest<{path: string, url: string}>(request);
    }
}